import React from 'react';
import { IconButton, ShareIcon } from 'src/components'; 

export default function ShareButton({ url, title, text, sx, iconColor, size = "small", iconSize = "small" }) {
  const shareData = {
    title: title || document.title,
    text: text || '',
    url: url || window.location.href,
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        // Optional: show success feedback
      } catch (err) {
        // User cancelled or error
        console.error('Error sharing:', err);
      }
    } else {
      // Fallback: copy URL to clipboard
      try {
        await navigator.clipboard.writeText(shareData.url);
        alert('Link copied to clipboard');
      } catch {
        alert('Sharing not supported and clipboard copy failed.');
      }
    }
  };

  return (
    <IconButton
      size={size}
      disableRipple
      sx={sx}
      aria-label="Share"
      onClick={handleShare}
    >
      <ShareIcon fontSize={iconSize ? iconSize : undefined} sx={{ color: iconColor }} />
    </IconButton>
  );
}
